module.exports = __webpack_public_path__ + "media/landing/slider-6-f8a31154.jpeg";